import {Box, Grid, TextField, Typography, styled} from "@mui/material";
import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import MWCaption from "../../components/MWCaption";

import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";

const CategoryFormContainer = styled(Grid)(({theme}) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "400px",
  backgroundColor: theme.palette.gray.main,
  "& p": {
    marginTop: "8px",
    textAlign: "center",
  },
}));

const CategoryFormContent = styled(Grid)(({theme}) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "240px",
  backgroundColor: theme.palette.gray.dark,

  border: `1px solid ${theme.palette.background.paper}`,
  borderRadius: "16px",
  boxShadow:
    "rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem",

  "& label": {
    fontWeight: 600,
    paddingRight: "8px",
  },
}));

type SubTitleColorProps = {
  captionColor?: string;
};

const FolderForm = ({captionColor}: SubTitleColorProps) => {
  const {control} = useFormContext();

  return (
    <React.Fragment>
      <MWCaption title="폴더 생성" color={captionColor} icon={<SystemUpdateAltIcon />} />
      <CategoryFormContainer container>
        <Grid item xs={12} sm={6} md={4} xl={4}>
          <Controller
            name="name"
            control={control}
            defaultValue={""}
            render={({field, fieldState: {error}}) => (
              <Box>
                <CategoryFormContent>
                  <label htmlFor="name">폴더 이름 : </label>
                  <TextField {...field} id="name" size="small" placeholder="폴더 이름" autoFocus />
                </CategoryFormContent>
                <Typography color="secondary">{error?.message}</Typography>
              </Box>
            )}
          />
        </Grid>
      </CategoryFormContainer>
    </React.Fragment>
  );
};

export default FolderForm;
